import { useEffect, useState } from 'react';
import { getLocalStorage } from '@shared/core';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

const localStorage = getLocalStorage();

const getDashboardVisitKey = (eventId: string): string => {
  return `${eventId}_firstDashboardVisit`;
};

/**
 * To track if this is the user's first visit to the dashboard for a specific event.
 */
export const useIsFirstDashboardVisit = (eventIdArg?: string) => {
  const [isFirstDashboardVisit, setIsFirstDashboardVisit] = useState(true);
  const { eventInfo, loading } = useEventInfo();

  const eventId = eventIdArg || eventInfo?.eventId;

  useEffect(() => {
    if (loading || !eventId) return;

    const visitKey = getDashboardVisitKey(eventId);
    const storedValue = localStorage.getItem(visitKey);
    setIsFirstDashboardVisit(storedValue === 'true');
  }, [loading, eventId]);

  const setFirstDashboardVisit = useEventCallback((value: boolean) => {
    if (!eventId) return;

    const visitKey = getDashboardVisitKey(eventId);
    localStorage.setItem(visitKey, value ? 'true' : undefined);
  });

  return { isFirstDashboardVisit, setFirstDashboardVisit };
};
